import { of } from 'rxjs';

import {
  TypedControl,
  TypedField,
} from 'common/dynamic-form/utils/form-preparing';
import { getHint } from 'common/dynamic-form/utils/get-hint';
import { isFullWidth } from 'common/dynamic-form/utils/is-full-width';
import { getLabel } from 'common/dynamic-form/wrappers/field-base/label/label.utils';

import { SkeletonProps } from './model';

import { ISPFieldConfig, ISPFieldType, ISPFormState } from '../../model';

/**
 * Get props for skeleton field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getSkeletonProps(
  control: TypedControl,
  field: TypedField,
  state: ISPFormState,
): SkeletonProps {
  let skeletonType: SkeletonProps['skeletonType'];

  switch (control.type) {
    case 'checkbox':
      skeletonType = 'checkbox';
      break;
    case 'textarea':
    case 'texteditor':
    case 'code':
      skeletonType = 'textarea';
      break;
    default:
      skeletonType = 'input';
      break;
  }

  const props: SkeletonProps = {
    originalControl: control.control,
    originalField: field.field,
    isHaveLabel: Boolean(getLabel(field.field, state.docSubject.value)),
    isHaveHint: Boolean(
      getHint(field.field.$name, state.docSubject.value, state.showHints),
    ),
    isFullWidth: isFullWidth(field.field, control.control),
    skeletonType,
  };

  if (control.control.$type === 'hidden') {
    props.isHidden = true;
    props.isHidden$ = of(true);
  }

  return props;
}

/**
 * Get config for skeleton field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getSkeletonConfig(
  control: TypedControl,
  field: TypedField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.Skeleton> {
  const props = getSkeletonProps(control, field, state);

  const config: ISPFieldConfig<ISPFieldType.Skeleton> = {
    type: ISPFieldType.Skeleton,
    props,
  };

  return config;
}
